<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

defineProps<{
  property: PropertyOnPage
}>();

const isFormOpen = defineModel<boolean>({ default: false });
function openForm() {
  isFormOpen.value = true;
}
</script>

<template>
  <IadStickySmallDevice>
    <div>
      <AgentTinyPreview :agent="property.agent" />
    </div>
    <div class="flex gap-s">
      <IadBtn
        size="large"
        icon
        @click="openForm"
      >
        <Icon name="iad-icon:mail" />
      </IadBtn>
      <AgentBtnPhone
        size="large"
        icon
        :agent="property.agent"
        :property
      />
    </div>
  </IadStickySmallDevice>
</template>
